<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Add {{ utils.getLangTerm('employees.singular', 'Employee') }}</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #f="ngForm" (ngSubmit)="onSubmit(f)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Full Name</mat-label>
          <input
            matInput
            placeholder="Full Name"
            [(ngModel)]="employee.contact_person"
            name="contact_person"
            type="text"
            id="contact_person"
            required/>
          <mat-hint>Enter the full name of the {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Email Address</mat-label>
          <input
            matInput
            placeholder="Email Address"
            [(ngModel)]="employee.email"
            name="email"
            type="email"
            id="email"
            required/>
          <mat-hint>Enter the email address of the {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <app-phone-input
          [idInput]="mobile_input_id"
          [numberInput]="employee.mobile"
          [countryCodeInput]="employee.mobile_country_code"
          [dialCodeInput]="employee.mobile_dial_code"
          [e164NumberInput]="employee.mobile_e164"
          (phoneDetailsOutput)="getOutputPhoneDetails($event)"
          [labelInput]="utils.getLangTerm('users.form.mobile', 'Mobile Number')"
          [hintInput]="'Enter the ' + utils.getLangTerm('users.form.mobile', 'Mobile Number') + ' of the ' + utils.getLangTerm('employees.singular', 'Employee') + '.'"
          required="true">
        </app-phone-input>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Job Title</mat-label>
          <mat-select matInput placeholder="Job Title" [(ngModel)]="employee.trade" name="trade" #trade>
            <mat-option *ngFor="let trade of trades" [value]="trade.name">{{ trade.name }}</mat-option>
          </mat-select>
          <mat-hint>Select the job title of the {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ utils.getLangTerm('users.form.notes', 'Notes') }}</mat-label>
      <textarea
        matInput
        rows="5"
        [placeholder]="utils.getLangTerm('users.form.notes', 'Notes')"
        [(ngModel)]="employee.pivot.notes"
        name="notes"
        id="notes">
        </textarea>
      <mat-hint>Enter {{ utils.getLangTerm('users.form.notes', 'Notes') }} for your {{ utils.getLangTerm('employees.singular', 'Employee') }}. The notes can only be seen in this active account by administrators.</mat-hint>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Address</mat-label>
      <input
        matInput
        placeholder="Address"
        [(ngModel)]="employee.address"
        name="address"
        type="text"
        id="address"/>
      <mat-hint>Enter the address of the company or {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
    </mat-form-field>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('users.form.suburb', 'Suburb') }}</mat-label>
          <input
            matInput
            [placeholder]="utils.getLangTerm('users.form.suburb', 'Suburb')"
            [(ngModel)]="employee.suburb"
            name="suburb"
            type="text"
            id="suburb"/>
          <mat-hint>Enter the {{ utils.getLangTerm('users.form.suburb', 'Suburb') }} of the company or {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('users.form.city', 'City') }}</mat-label>
          <input
            matInput
            [placeholder]="utils.getLangTerm('users.form.city', 'City')"
            [(ngModel)]="employee.city"
            name="city"
            type="text"
            id="city"/>
          <mat-hint>Enter the {{ utils.getLangTerm('users.form.city', 'City') }} of the company or {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ utils.getLangTerm('users.form.postal_code', 'Postal Code') }}</mat-label>
          <input
            matInput
            [placeholder]="utils.getLangTerm('users.form.postal_code', 'Postal Code')"
            [(ngModel)]="employee.postal_code"
            name="postal_code"
            type="text"
            id="postal_code"/>
          <mat-hint>Enter the {{ utils.getLangTerm('users.form.postal_code', 'Postal Code') }} of the company or {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
          <mat-label>Country</mat-label>
          <input
            matInput
            placeholder="Country"
            [(ngModel)]="employee.country"
            name="country"
            type="text"
            id="country"/>
          <mat-hint>Enter the country of the company or {{ utils.getLangTerm('employees.singular', 'Employee') }}.</mat-hint>
        </mat-form-field>
      </div>
    </div>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">
    <button
      mat-raised-button
      [disabled]="!f.valid || mobile_error_state"
      class="my-2 ml-1 mr-2"
      type="submit"
      color="primary"
      id="save_button">
      <mat-icon>save</mat-icon>
      Save
    </button>
  </mat-dialog-actions>

</form>
